import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <div className="border_subtitle">Step 3</div>
                                                <p>Once you’ve done that, join the dots so you can see where the
                                                    peaks and troughs are.</p>
                                                <div className="border_subtitle">Step 4</div>
                                                <div className="uiheading"><p>Now, for each of the peaks think about
                                                    what made it particularly positive. If you’re stuck, ask
                                                    yourself the following questions:</p></div>
                                                <ul className="greenbullet-list">
                                                    <li>What was the environment like?</li>
                                                    <li>What was motivating you?</li>
                                                    <li>What skills were you using?</li>
                                                    <li>What did you enjoy most?</li>
                                                    <li>What were you really good at?</li>
                                                    <li>What did you get rewarded/recognised for?</li>
                                                    <li>What were you proud of?</li>
                                                </ul>

                                                <div className="border_subtitle">Step 5</div>
                                                <p>Look at the peaks and see what they have in common. Are there any
                                                    skills or types of activity
                                                    which are common to all the high points of your career? This
                                                    should give an indication of the
                                                    types of skills you could consider to be your strengths. Once
                                                    you have identified the commonalities,
                                                    make a list and use it in the next task, ‘uncovering signature
                                                    strengths’.</p>
                                            </div>
                                                <div className="circle_title"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>CAREER ANALYSIS CHART EXAMPLE
                                                </div>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/graph_yourself.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}